/**
 * List of Google Play / App Store SKUs eligible for premium
 * IAP.hasAccessAny(skus);
 */
export const premiumSKUs = [
    "premium_access_monthly_sku_2021",
    "premium_access_annual_sku_2021",
    "four_in_one_monthly_sku",
    "four_in_one_annual_sku",
    "four_in_one_monthly_sku_7",
    "four_in_one_premium_annual_sku",
    "full_access_monthly",
    "full_access_monthly_sale",
    "full_access_monthly_2022",
    "full_access_2022_monthly",
];
